<template>
  <main-layout>

    <div slot="left-side">
      <menubar screenIdParam="M-06-78"></menubar>
    </div>
    <div slot="header">
      <head-title class="cancel-width">
        <label slot="title">
          <label slot="title">{{$t("label.taxTemplate.taxTemplate")}}</label>
        </label>
        <lvory-but
          @click="back"
          slot="cancel">
            {{ $t("button.common.data.cancel") }}
        </lvory-but>
        <narrow-down
          v-auth="{ auth: '010221' }"
          slot="create"
          @click="taxTemplateAdd">
          {{"新規作成"}}
        </narrow-down>
      </head-title>
    </div>

    <div slot="body">
      <div class="panel-search m-top-5">
        <div class="search-form">
          <!--  テンプレート名（部分一致）   -->
          <div class="fm-row">
            <el-input
              class="new-input-style"
              v-model="query.templateName"
              :placeholder="$t('label.taxTemplate.templateNamePartial')"
              maxlength="50">
            </el-input>
          </div>
          <!--  検索   -->
          <div>
            <div class="btn-area fm-row">
              <narrow-down @click="searchTemplate">
                {{$t("button.common.narrow")}}
              </narrow-down>
              <cancel-narrow-down class="link-primary margin-left-8" @click="clearFaq">
                {{$t("button.common.cancelNarrow")}}
              </cancel-narrow-down>
            </div>
          </div>
        </div>
      </div>
      <div v-for="(value, index) of result" :key="index" class="template-card">
        <sale-tax-template-card
          :result = "value"
          @templateEdit = templateEdit
        />
      </div>

      <div v-if="this.result.length == 0">
        <div class="no-data">
          {{$t("message.common.NoData")}}
        </div>
      </div>

      <loading-dialog :dialogVisible="showLoading" />

    </div>

  </main-layout>
</template>

<script>
import Menubar from "@/components/leftmenu/DashBoard"
import MainLayout from "@/layout/NewDesignLayout"
import SystemManageApi from "@/api/SystemManageApi"
import errorCodeMsg from "@/utils/error-code-msg"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown"
import headTitle from "@/components/common/head/head";
import saleTaxTemplateCard from "@/components/saleTax/saleTaxTemplateCard";
import LvoryBut from "@/components/common/generalButton/LvoryBut";
import LoadingDialog from "@/components/common/loading/LoadingDialog"

export default {
  name:'FaqManagement',
  components: {
        MainLayout: MainLayout,
        narrowDown: narrowDown,
        cancelNarrowDown: cancelNarrowDown,
        Menubar,
        headTitle,
        saleTaxTemplateCard,
        LvoryBut,
        LoadingDialog
  },
  data() {
    return {
      query: {
        ownerId: null,
        templateName: null
      },
      result: [
        {
          templateId: null,
          templateName: null,
          taxRate: null,
          decimalManageMethod: null
        }
      ],
      showLoading: false,
    }
  },
  created() {
    this.$authCheck("010220");

    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/owners/search",
        title: "label.router.owner",
      },
      {
        path: "",
        title: "label.router.ownerSetting",
      },
      {
        path: "",
        title: "消費税テンプレート",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);

  },
  watch: {

  },
  mounted() {
    this.query.ownerId = this.$route.query.ownerId
    this.ownerDetail = JSON.parse(this.$route.query.ownerDetail)
    this.searchTemplate()
  },
  methods: {
    back() {
      this.$router.push({
        name: "system-owner-setting-edit",
        query: {
          orgId: this.query.ownerId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },

    roundToDecimal(num, decimals) {
      const factor = Math.pow(10, decimals); // 10^n
      return Math.round(num * factor) / factor;
    },

    taxTemplateAdd(){
      this.$router.push({
        name: "saleTax-template-create",
        query: {
          ownerId: this.query.ownerId
        }
      })
    },

    searchTemplate(){
      this.showLoading = true
      this.result = []
      SystemManageApi.SystemTaxTemplateSearch({
        ownerId:this.query.ownerId,
        templateName: this.query.templateName,
        pageSize: 1000,
        pageNumber: 1,
        includeDeletedDataFlag: true
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({data}) => {
        if(data.statusCode == "Success") {
          for(let index of data.body.body){
            this.result.push({
              templateName: index.templateName,
              templateId: index.templateId,
              taxRate: this.roundToDecimal(index.taxRate * 100, 5),
              decimalManageMethod: index.decimalManageMethod
            })
          }

          // if(this.result.length == 0){
          //   this.$messageIotSuccess("データなし")
          // }
        }
      }).finally(() => {
        this.showLoading = false
      })
    },

    clearFaq(){
      this.query.templateName = null
    },

    templateEdit(templateId) {
      this.$router.push({
        name: "saleTax-template-create",
        query: {
          templateId: templateId
        }
      })
    }

  }
}
</script>

<style scoped lang="scss">

.no-data{
  text-align: center;
  color: #909399;
}

::v-deep .new-input-style {
  .el-input__inner{
    width: 324px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #F2F2ED;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
  }
}

.template-card {
  display: inline-block;
  width: 519px;
  margin-left: 20px;
  margin-top: 22px;
}
</style>
